import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';
import ArtistManagement from './ArtistManagement';
import ArtistProfileReview from './ArtistProfileReview';
import './ArtistsTabs.css';

const ArtistsTabs = () => {
  const [showAddArtist, setShowAddArtist] = useState(false);

  return (
    <div className="artists-tabs-page" data-testid="artists-tabs">
      <div className="artists-page-header" data-testid="artists-page-header">
        <h1>Artist Profiles</h1>
        <button
          className="artists-tabs-page-add-btn"
          onClick={() => setShowAddArtist(true)}
          data-testid="add-artist-btn"
        >
          <Plus size={18} />
          <span>Add Artist</span>
        </button>
      </div>

      <div className="artists-tab-content" data-testid="artists-tab-content">
        <ArtistProfileReview />
      </div>

      {showAddArtist && (
        <div className="artists-tabs-page-overlay" data-testid="add-artist-overlay">
          <div className="artists-tabs-page-panel">
            <div className="artists-tabs-page-panel-header">
              <h2>Manage Public Profiles</h2>
              <button
                className="artists-tabs-page-panel-close"
                onClick={() => setShowAddArtist(false)}
                data-testid="close-add-artist"
              >
                <X size={22} />
              </button>
            </div>
            <div className="artists-tabs-page-panel-body">
              <ArtistManagement />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ArtistsTabs;
